import * as yup from 'yup'

yup.addMethod(yup.string, 'ipv4Socket', function (message) {
  return this.matches(/^(\d{1,3}\.){3}\d{1,3}:\d+$/, {
    message,
    excludeEmptyString: true,
  }).test('ipv4-socket', message, (value) => {
    if (value === undefined || value.trim() === '') return true

    const [ip, port] = value.split(':')

    const invalidOctet = ip.split('.').find((o) => {
      const n = parseInt(o, 10)
      return n < 0 || n > 255
    })

    if (invalidOctet !== undefined) return false

    const portNum = parseInt(port, 10)
    return Number.isInteger(portNum) && port === portNum.toString()
  })
})

// host:port или IPv4:port — адрес контроллера Eltex (auth.address в Асгарде — socket address).
yup.addMethod(yup.string, 'hostSocket', function (message) {
  return this.test('host-socket', message, (value) => {
    if (value === undefined || value.trim() === '') return true

    const separator = value.lastIndexOf(':')
    if (separator === -1) return false

    const host = value.slice(0, separator)
    const port = value.slice(separator + 1)
    const hostValid =
      /^[A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])?)*$/.test(
        host
      )
    const portNum = parseInt(port, 10)

    return (
      hostValid && /^\d{1,5}$/.test(port) && portNum >= 1 && portNum <= 65535
    )
  })
})

yup.addMethod(yup.string, 'rtspLink', function (message) {
  return this.matches(/(rtsp):\/\/([^\s@]+)@([^\s:]+)(?::([0-9]+))?(\/.*)/, {
    message,
    excludeEmptyString: true,
  }).test('ip', message, (value) => {
    return value === undefined || value.trim() === ''
      ? true
      : value.split('.').find((i) => parseInt(i, 10) > 255) === undefined
  })
})
